var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-list-item-label px-2",style:(_vm.customStyle)},[_c('font-awesome-icon',{staticClass:"content-label-icon mr-1",attrs:{"icon":['fad', _vm.label.icon]}}),_c('div',{staticClass:"label-name"},[_vm._v(" "+_vm._s(_vm.label.labelName)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }